import { BaseClass } from '../base/BaseClass';

import SmoothScroll from 'smooth-scroll';

export class SmoothScroller extends BaseClass {
  /**
   *
   * Holds the smooth scroll object in the dom
   * @type {Object}
   *
   */
  smoothScroll;

  /**
   *
   * The target for the smooth scroll class
   * @type {String}
   *
   */
  identifier;

  /**
   * Smooth scroll options
   *
   * @type {Object}
   */
  options;

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * @desc Handles the mobile burger menu opening and closing
   *
   */
  constructor(identifier) {
    super(identifier);
    // console.log('identifier');
    // console.log(identifier);
    this.identifier = identifier;
    this.options = arguments[2];
    this.init();
  }

  /**
   * Called to init the class if target element is present.
   */
  init = () => {
    this.smoothScroll = new SmoothScroll(this.identifier, {
      ...this.options,
      offset: this.offset,
    });
  };

  /**
   * Controls the offset of the smooth scroll.
   *
   * @param {Object} anchor - The scroll target HTML node.
   * @param {Object} toggle - The scroll target link HTML node.
   *
   * @return {integer} The desired offset in pixels.
   */
  offset = (anchor, toggle) => {
    let offset = anchor.classList.contains('section-grey') ? 0 : 50;

    if (!!document.querySelector('#toolbar-administration')) {
      offset += 80;
    }

    return offset;
  };
}
